import { useCallback, useEffect, useState } from 'react';

export const MARGIN_MODE_RECOGNISED = 'recognised';
export const MARGIN_MODE_COMBINED = 'combined';
const STORAGE_KEY = 'margin_view_mode';

/**
 * Margin view mode shared by the Margins page, Reports → Sales Performance
 * and the Dashboard margin tile: recognised revenue only, or recognised plus
 * the in-flight pipeline. Remembered per browser.
 */
export const useMarginViewMode = () => {
  const [mode, setModeState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === MARGIN_MODE_COMBINED
        ? MARGIN_MODE_COMBINED : MARGIN_MODE_RECOGNISED;
    } catch { return MARGIN_MODE_RECOGNISED; }
  });

  useEffect(() => {
    const onChange = (e) => {
      if (e.key === STORAGE_KEY) {
        setModeState(e.newValue === MARGIN_MODE_COMBINED ? MARGIN_MODE_COMBINED : MARGIN_MODE_RECOGNISED);
      }
    };
    window.addEventListener('storage', onChange);
    return () => window.removeEventListener('storage', onChange);
  }, []);

  const setMode = useCallback((next) => {
    setModeState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* ignore */ }
  }, []);

  return { mode, setMode, includePipeline: mode === MARGIN_MODE_COMBINED };
};

export default useMarginViewMode;
